
import { defineComponent, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { ElLoadingService, ElMessage } from 'element-plus';

import { ArrowDown } from '@element-plus/icons-vue';

import { useUserStore } from '@/store/modules/user';
import { hasRoutePermission } from '@/router';

import UpdPassWord from '@/components/UpdPassWord/index.vue';
import BindMobile from '@/components/BindMobile/index.vue';
import WMSClientDialog from '@/components/WMSClientDialog/index.vue';
import SvgIcon from '@/components/Icons/SvgIcon.vue';

import { FILESERVICE } from '@/config/defaultSetting';

import HeaderTabs from '@/components/HeaderTabs/index.vue';
import TabPanel from '@/components/HeaderTabs/tab-panel.vue';

export default defineComponent({
  name: 'Header',
  components: {
    ArrowDown,
    SvgIcon,
    UpdPassWord,
    BindMobile,
    WMSClientDialog,
    HeaderTabs,
    TabPanel,
  },
  setup() {
    const userStore = useUserStore();
    const route = useRoute();

    const dialogVisible = ref<boolean>(false);
    const visibleDialogName = ref<string>('');
    const tabsActiveIndex = ref(route.name?.toString() || 'Home');

    async function openPassword() {
      dialogVisible.value = true;
      visibleDialogName.value = 'update-password';
    }
    async function bindMobile() {
      dialogVisible.value = true;
      visibleDialogName.value = 'bind-mobile';
    }
    async function openWMSClient() {
      dialogVisible.value = true;
      visibleDialogName.value = 'WMS-client';
    }
    function logout() {
      const loadingInstance = ElLoadingService({ text: '登出中' });
      userStore.logout().finally(() => {
        loadingInstance.close();
      });
    }

    function openSystemByCode(code: string) {
      let targetUrl: string | undefined = '';
      switch (code) {
        case 'TMS':
          targetUrl = process.env.VUE_APP_TMS_SERVERS_URL;
          break;
        case 'BMS':
          targetUrl = process.env.VUE_APP_BMS_SERVERS_URL;
          break;
        case 'PMS':
          targetUrl = process.env.VUE_APP_PMS_SERVERS_URL;
          break;
        case 'ODS':
          targetUrl = process.env.VUE_APP_ODS_SERVERS_URL;
          break;
        case 'CSP':
          targetUrl = process.env.VUE_APP_CSP_SERVERS_URL;
          break;
        case 'FPL':
          targetUrl = process.env.VUE_APP_FPL_DEFAULT_SERVERS_URL;
          break;
        case 'FPL-WECHAT':
          targetUrl = process.env.VUE_APP_FPL_WECHAT_SERVERS_URL;
          break;
        case 'FPL-EXPRESS':
          targetUrl = process.env.VUE_APP_FPL_EXPRESS_SERVERS_URL;
          break;
        default:
          return;
      }

      targetUrl && window.open(targetUrl, '_blank');
    }
    function onDialogClose() {
      dialogVisible.value = false;
      visibleDialogName.value = '';
    }
    function hasnotPermissionHandle() {
      ElMessage.warning('抱歉,您的账号没有权限进入该页面');
    }
    function hasApplicationPermission(applicationCode: string | undefined) {
      if (!applicationCode) {
        return true;
      } else {
        const index =
          userStore.getApplicationPermission.indexOf(applicationCode);
        return index !== -1;
      }
    }
    function onLightningClick() {
      window.open(
        `${process.env.VUE_APP_OA_PORTAL_URL}/DemandManagement/home`,
        '_blank'
      );
    }

    watch(route, (value) => {
      tabsActiveIndex.value = value.name?.toString() || 'Home';
    });

    return {
      openSystemByCode,
      tabsActiveIndex,
      userStore,
      dialogVisible,
      visibleDialogName,
      openPassword,
      bindMobile,
      openWMSClient,
      onDialogClose,
      logout,
      hasRoutePermission,
      hasnotPermissionHandle,
      hasApplicationPermission,
      FILESERVICE,
      onLightningClick,
    };
  },
});
